var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "col content-spacing", attrs: { role: "main" } },
    [
      _c(
        "b-card-group",
        { staticStyle: { "margin-top": "20px" }, attrs: { deck: "" } },
        [
          _c(
            "b-card",
            {
              attrs: { title: "Usuários Recentes" },
              scopedSlots: _vm._u(
                [
                  !_vm.viewData.pending.loading &&
                  _vm.viewData.pending.list.length > 0
                    ? {
                        key: "footer",
                        fn: function() {
                          return [
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.getLastUpdate(_vm.viewData.pending.list)
                                )
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    : null
                ],
                null,
                true
              )
            },
            [
              _vm.viewData.pending.loading ? _c("loading-list") : _vm._e(),
              _vm._v(" "),
              !_vm.viewData.pending.loading &&
              _vm.viewData.pending.list.length > 0
                ? _c(
                    "b-list-group",
                    _vm._l(_vm.viewData.pending.list, function(item) {
                      return _c(
                        "b-list-group-item",
                        { key: item.id },
                        [
                          _c(
                            "b-badge",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: { variant: "info" }
                            },
                            [_vm._v(_vm._s(_vm.formatCalendar(item.createdAt)))]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                href: `/#/user/edit/${item.id}/${item.accountProfile}`
                              }
                            },
                            [_vm._v(_vm._s(item.name))]
                          ),
                          _vm._v(" "),
                          _c("b-badge", { attrs: { variant: "light" } }, [
                            _vm._v(_vm._s(item.socialNumber))
                          ]),
                          _vm._v(" "),
                          item.loading
                            ? _c("b-icon", {
                                staticStyle: { float: "right" },
                                attrs: {
                                  icon: "arrow-clockwise",
                                  animation: "spin",
                                  "font-scale": "2"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    1
                  )
                : !_vm.viewData.pending.loading &&
                  _vm.viewData.pending.list.length === 0
                ? _c("empty-list")
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-card",
            { attrs: { title: "Cadastros pendentes" } },
            [
              _vm.viewData.pendingRegisters.loading
                ? _c("loading-list")
                : _vm._e(),
              _vm._v(" "),
              !_vm.viewData.pendingRegisters.loading &&
              _vm.viewData.pendingRegisters.list.length > 0
                ? _c(
                    "b-list-group",
                    _vm._l(_vm.viewData.pendingRegisters.list, function(item) {
                      return _c(
                        "b-list-group-item",
                        { key: item.id },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: `/#/user/view/${item.id}/consumer`
                              }
                            },
                            [_vm._v(_vm._s(item.name))]
                          ),
                          _vm._v(" "),
                          _c("b-badge", { attrs: { variant: "light" } }, [
                            _vm._v(_vm._s(item.socialNumber))
                          ])
                        ],
                        1
                      )
                    }),
                    1
                  )
                : !_vm.viewData.pendingRegisters.loading &&
                  _vm.viewData.pendingRegisters.list.length === 0
                ? _c("empty-list")
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-card-group",
        { staticStyle: { "margin-top": "10px" }, attrs: { deck: "" } },
        [
          _c(
            "b-card",
            {
              attrs: { title: "Últimas Instalações" },
              scopedSlots: _vm._u(
                [
                  !_vm.viewData.installation.loading &&
                  _vm.viewData.installation.list.length > 0
                    ? {
                        key: "footer",
                        fn: function() {
                          return [
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.getLastUpdate(
                                    _vm.viewData.installation.list
                                  )
                                )
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    : null
                ],
                null,
                true
              )
            },
            [
              _vm.viewData.installation.loading ? _c("loading-list") : _vm._e(),
              _vm._v(" "),
              !_vm.viewData.installation.loading &&
              _vm.viewData.installation.list.length > 0
                ? _c(
                    "b-list-group",
                    _vm._l(_vm.viewData.installation.list, function(item) {
                      return _c(
                        "b-list-group-item",
                        { key: item.id },
                        [
                          _c(
                            "b-badge",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: { variant: "info" }
                            },
                            [_vm._v(_vm._s(_vm.formatCalendar(item.createdAt)))]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: { href: `/#/installation/edit/${item.id}` }
                            },
                            [
                              _c("b-badge", { attrs: { variant: "light" } }, [
                                _vm._v(
                                  _vm._s(item.installationNumber) +
                                    " - " +
                                    _vm._s(item.address) +
                                    " -\n                " +
                                    _vm._s(item.state)
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                : !_vm.viewData.installation.loading &&
                  _vm.viewData.installation.list.length === 0
                ? _c("empty-list")
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-card",
            {
              attrs: { title: "Últimas Faturas" },
              scopedSlots: _vm._u(
                [
                  !_vm.viewData.billing.loading &&
                  _vm.viewData.billing.list.length > 0
                    ? {
                        key: "footer",
                        fn: function() {
                          return [
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.getLastUpdate(_vm.viewData.billing.list)
                                )
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    : null
                ],
                null,
                true
              )
            },
            [
              _vm.viewData.billing.loading ? _c("loading-list") : _vm._e(),
              _vm._v(" "),
              !_vm.viewData.billing.loading &&
              _vm.viewData.billing.list.length > 0
                ? _c(
                    "b-list-group",
                    _vm._l(_vm.viewData.billing.list, function(item) {
                      return _c(
                        "b-list-group-item",
                        { key: item.id },
                        [
                          _c(
                            "b-badge",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: { variant: "info" }
                            },
                            [_vm._v(_vm._s(_vm.formatCalendar(item.createdAt)))]
                          ),
                          _vm._v(" "),
                          _c("b-badge", { attrs: { variant: "light" } }, [
                            _vm._v(
                              _vm._s(_vm._f("currency")(item.value)) +
                                " - " +
                                _vm._s(item.installationAddres) +
                                " -\n              " +
                                _vm._s(_vm.getStatusName(item.status))
                            )
                          ])
                        ],
                        1
                      )
                    }),
                    1
                  )
                : !_vm.viewData.billing.loading &&
                  _vm.viewData.billing.list.length === 0
                ? _c("empty-list")
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-card",
            {
              attrs: { title: "Últimas Notas Fiscais" },
              scopedSlots: _vm._u(
                [
                  !_vm.viewData.invoice.loading &&
                  _vm.viewData.invoice.list.length > 0
                    ? {
                        key: "footer",
                        fn: function() {
                          return [
                            _c("small", { staticClass: "text-muted" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.getLastUpdate(_vm.viewData.invoice.list)
                                )
                              )
                            ])
                          ]
                        },
                        proxy: true
                      }
                    : null
                ],
                null,
                true
              )
            },
            [
              _vm.viewData.invoice.loading ? _c("loading-list") : _vm._e(),
              _vm._v(" "),
              !_vm.viewData.invoice.loading &&
              _vm.viewData.invoice.list.length > 0
                ? _c(
                    "b-list-group",
                    _vm._l(_vm.viewData.invoice.list, function(item) {
                      return _c(
                        "b-list-group-item",
                        { key: item.id },
                        [
                          _c(
                            "b-badge",
                            {
                              staticStyle: { "margin-right": "10px" },
                              attrs: { variant: "info" }
                            },
                            [_vm._v(_vm._s(_vm.formatCalendar(item.createdAt)))]
                          ),
                          _vm._v(" "),
                          _c("a", { attrs: { href: item.url } }, [
                            _vm._v(_vm._s(item.description.substring(0, 100)))
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: { href: `/#/user/${item.userId}/invoices` }
                            },
                            [
                              _c("b-badge", { attrs: { variant: "light" } }, [
                                _vm._v(_vm._s(item.userName))
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                : !_vm.viewData.invoice.loading &&
                  _vm.viewData.invoice.list.length === 0
                ? _c("empty-list")
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }